import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import InfoMessage from "../components/common/InfoMessage";
import Loader from "../components/common/Loader";
import OfflineMeetingCard from "../components/widgets/OfflineMeetingCard";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

const OfflineMeetingsPage: React.FC<RouteComponentProps> = ({ history }) => {
  const rootStore = useContext(RootStoreContext);
  const { loadMeetingsFromDb, meetingsArray, currentTenant } =
    rootStore.offlineStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["nativeapp"], translationHookOptions);

  useEffect(() => {
    if (currentTenant) {
      loadMeetingsFromDb(currentTenant.id).then().catch();
      const scrollableElement = document.querySelector(".contenitoreRiunioni");
      if (scrollableElement) disableBodyScroll(scrollableElement);
      return () => {
        const scrollableElement = document.querySelector(
          ".contenitoreRiunioni"
        );
        if (scrollableElement) enableBodyScroll(scrollableElement);
      };
    }
  }, [currentTenant, loadMeetingsFromDb]);

  if (!meetingsArray) return <Loader />;

  return (
    <>
      <Container>
        <Row className="contenitoreRiunioni">
          {meetingsArray.length < 1 ? (
            <InfoMessage
              message={t("no_downloaded_meetings")}
              color={theme!.infoMessageColor}
              icon="fa fa-exclamation-circle fa-3x"
            />
          ) : (
            meetingsArray.map((m) => (
              <Col xs={12} md={6} lg={4} xl={4} key={m.id}>
                <OfflineMeetingCard meeting={m} />
              </Col>
            ))
          )}
        </Row>
      </Container>
    </>
  );
};

export default observer(OfflineMeetingsPage);
